import { reactive, toRefs } from "vue"

// Shared topbar visibility. The scrollable pages (MenuPage, ContentPage, ...)
// forward their ion-content ionScroll event via handleScroll(); App.vue reads
// `topbarsHidden` to slide the company header / tabs / filters out of view
// while the user scrolls down, and back in as soon as they scroll up.
const state = reactive({
    topbarsHidden: false
})

let lastScrollTop = 0
//cached scroll container of the active page (resolved lazily from ion-content);
//needed to measure distance from the bottom, which the event doesn't expose
let scrollEl = null

//while the content rubber-bands at the very bottom, scrollTop overshoots and
//snaps back, producing fake "scrolling up" deltas. Reacting to them toggles the
//bars, which changes layout height and feeds back into more scroll events — a
//jittery loop. Freeze the state within this margin of the bottom.
const BOTTOM_FREEZE_MARGIN = 60

function handleScroll(event) {
    //lazily cache the real scroll container (Ionic exposes it asynchronously)
    let content = event.target
    if (!scrollEl && content && content.getScrollElement) {
        content.getScrollElement().then((el) => { scrollEl = el })
    }

    let scrollTop = event.detail.scrollTop
    let delta = scrollTop - lastScrollTop
    lastScrollTop = scrollTop

    //ignore everything inside the bottom overscroll/bounce zone
    if (scrollEl) {
        let distanceFromBottom = scrollEl.scrollHeight - scrollEl.clientHeight - scrollTop
        if (distanceFromBottom < BOTTOM_FREEZE_MARGIN) {
            return
        }
    }

    //always reveal when at/near the very top
    if (scrollTop <= 0) {
        state.topbarsHidden = false
        return
    }

    //ignore tiny jitter so the bars don't flicker
    if (Math.abs(delta) < 6) {
        return
    }

    if (delta > 0 && scrollTop > 40) {
        //scrolling down
        state.topbarsHidden = true
    } else if (delta < 0) {
        //scrolling up
        state.topbarsHidden = false
    }
}

//a fresh view starts scrolled to the top with its own scroll container
function reset() {
    state.topbarsHidden = false
    lastScrollTop = 0
    scrollEl = null
}

export default {
    ...toRefs(state),
    handleScroll,
    reset
}
